/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';
import _ from 'lodash';
import SimpleInput from '/client/src/components/forms/simpleInput';
import { GET } from '/client/src/api';
import { CheckIcon } from '../checkIcon';
import '../checkout.scss';
import './codeForm.scss';

type VipCodesPropsType = {
  eventDetail: {
    tickets: [],
    id: string
  },
  visibleTickets: [],
  visibleVipTickets: [],
  onHandleAddToVipTickets: () => void
};

const VipCodeForm = ({
  eventDetail,
  visibleTickets,
  visibleVipTickets,
  onHandleAddToVipTickets
}: VipCodesPropsType): React.Element<'div'>  => {
  const [vipCode, setVipCode] = React.useState('');
  // 1 - loading, 2 - success, 3 - error
  const [codeState, setCodeRes] = React.useState(0);

  const removeMessage = () => {
    setTimeout(() => {
      setCodeRes(0);
      setVipCode('');
    }, 2000);
  };

  const checkVipCode = async () => {
    setCodeRes(1);

    try {
      const { result } = await GET(`/api/v1/1/events/${eventDetail.id}/vipcodes/${vipCode}`);
      const data = result[0];

      // eslint-disable-next-line
      // TODO: must check exist on already showed ticket && exist ticket in this event && not exist already showed this secret ticket

      if (!!_.size(data.applied_to_tickets)) {
        const isCanShow = _.map(eventDetail.tickets, (i: {}): any => (
          // check if exist in current event
          _.find(data.applied_to_tickets, (c: {}): any => (_.toString(c.id) === _.toString(i.id)))
        )).filter((f: {}): void =>
          f !== undefined // clear empty on map
          && // check if exist in already shoved tickets (no set hidden)
          !_.some(visibleTickets, (c: {}): any => (_.toString(c.id) === _.toString(f.id)))
          && // check if already in shoved vipTickets
          !_.some(visibleVipTickets, (c: {}): any => (_.toString(c.id) === _.toString(f.id)))
        );

        if (!!_.size(isCanShow)) onHandleAddToVipTickets(isCanShow);

        setCodeRes(2);
        removeMessage();
      }
    }  catch (error) {
      console.error(error);
      removeMessage();
      setCodeRes(3);
    }
  };

  return (
    <div className={`
      sparxo-checkout-codeForm_container
      ${codeState === 2 ? 'sparxo-checkout-codeForm_containerSuccess' : ''}
      ${codeState === 3 ? 'sparxo-checkout-codeForm_containerError' : ''}
      `}
    >
      {codeState === 0 ?
        <form className="sparxo-checkout-codeForm_form">
          <div className="sparxo-checkout-codeForm_title">VIP CODE</div>
          <div className="sparxo-checkout-codeForm_inputContainer">
            <SimpleInput
              type='text'
              id={'splashPage-vipCode'}
              name='vipCode'
              value={vipCode}
              classes={{ input: 'sparxo-checkout-codeForm_input' }}
              style={{ width: '100%', marginRight: '14px' }}
              placeholder='Enter code here'
              onChange={(e: any): void => setVipCode(e.target.value)}
            />
            <button
              type="submit"
              className="sparxo-checkout_action_btn"
              onClick={(e: any) => {
                e.preventDefault();
                checkVipCode();
              }}
            >Apply code
            </button>
          </div>
        </form>
        :
        <span className="sparxo-checkout-codeForm_codeStatus splashPage-codeStatus">
          {codeState === 1 &&
            <div className="sparxo-checkout-codeForm_loaderBlock">
              <span className='csspinner' />
            </div>
          }
          {codeState === 2 && <><CheckIcon/> Your code has been applied!</>}
          {codeState === 3 && <>Something went wrong. Try again later.</>}
        </span>
      }
    </div>
  );
};

export default VipCodeForm;
